import BaseAPI from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";
import { recipeRoute } from "../routes";

export default class RecipeAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, recipeRoute, "recipe");
    }

    async CostPreview(payload) {
        return this._request("post", this._url("/cost-preview"), payload);
    }

    async MarkArchived(id) {
        const result = await this._request(
            "post",
            `${getAPIUrlV2("control/recipes")}/mark-archived?id=${id}`
        );
        this._emit("mark-archived", id);
        return result;
    }
}
